export const BACKEND_URI = 'https://ufinda-v0-01.onrender.com';

export const TEST_URL = 'https://clement-nonderisive-oxymoronically.ngrok-free.dev'

// export const DOWNLOADLINK = 'https://expo.dev/artifacts/eas/hAu0fnGHHV3hOAs_q7PXDxnGX2KVaAgQwhX9UyJfsvo.apk'
export const X_PROFILE = 'https://x.com/uFindaApp'

export const INSTAGRAM_PROFILE = 'https://www.instagram.com/ufinda_app/'

export const LINKEDIN_PROFILE = ''

export const FACEBOOK_PROFILE = 'https://www.facebook.com/profile.php?id=61591458990537'

export const DOWNLOADLINK = 'https://expo.dev/artifacts/eas/q_ru--Az6grpITvP2VfUun9QDvug-_YkytfIiCl3W7I.apk'
